module.exports = __webpack_public_path__ + "static/img/invest-TMT7.f09e331.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT7.jpg
// module id = 9hdr
// module chunks = 0